"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OidcClient = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = require("@ori/axios");
var _OidcTokenStorage = require("./storage/OidcTokenStorage");
var _CryptoUtils = require("./utils/CryptoUtils");
var _getRandomInt = require("./utils/getRandomInt");
var _singleton = require("./utils/singleton");
var _class;
/* eslint-disable no-restricted-globals -- needed */ var RANDOM_NUMBER_LOWER_BOUND = 1;
var RANDOM_NUMBER_UPPER_BOUND = Math.pow(2, 32);
var OidcClient = exports.OidcClient = (0, _singleton.singleton)(_class = function OidcClient(options, oauthOptions) {
    var _this = this;
    _class_call_check(this, OidcClient);
    (0, _defineProperty2.default)(this, "options", void 0);
    (0, _defineProperty2.default)(this, "oauthOptions", void 0);
    (0, _defineProperty2.default)(this, "storage", new _OidcTokenStorage.OidcTokenStorage());
    (0, _defineProperty2.default)(this, "doLogin", function() {
        var state = "S".concat((0, _getRandomInt.getRandomInt)(RANDOM_NUMBER_LOWER_BOUND, RANDOM_NUMBER_UPPER_BOUND)).concat(Date.now());
        var nonce = "N".concat((0, _getRandomInt.getRandomInt)(RANDOM_NUMBER_LOWER_BOUND, RANDOM_NUMBER_UPPER_BOUND)).concat(Date.now());
        var redirectUri = new URL(_this.options.callbackUrl, location.origin).toString();
        var codeVerifier = _CryptoUtils.CryptoUtils.generateCodeVerifier();
        var codeChallenge = _CryptoUtils.CryptoUtils.generateCodeChallenge(codeVerifier);
        _this.storage.state.set(state);
        _this.storage.nonce.set(nonce);
        _this.storage.redirectUri.set(redirectUri);
        _this.storage.redirectUrl.set(_this.options.redirectUrl);
        _this.storage.codeVerifier.set(codeVerifier);
        var url = new _axios.SafeURL("/identity/connect/authorize", _this.oauthOptions.identityUrl || location.origin);
        /* eslint-disable @typescript-eslint/naming-convention -- Query params have different style */ url.search = new URLSearchParams({
            nonce: nonce,
            state: state,
            acr_values: _this.oauthOptions.acrValues,
            client_id: _this.oauthOptions.clientId,
            prompt: 'login',
            redirect_uri: redirectUri,
            response_type: 'code',
            scope: _this.oauthOptions.scope,
            code_challenge_method: 'S256',
            code_challenge: codeChallenge
        }).toString();
        /* eslint-enable @typescript-eslint/naming-convention */ window.location.href = url.href;
    });
    this.options = options;
    this.oauthOptions = oauthOptions;
}) || _class; //# sourceMappingURL=OidcClient.js.map
